import { useCallback, useState } from "react";
import { COVER_BASE, JOB_LABEL } from "@/lib/jobs";

const round = (v) => Math.round(v * 10) / 10;

export function usePlayDraft(cfg) {
  const [draft, setDraft] = useState(null);
  const [selected, setSelected] = useState(null);

  const start = useCallback((play, positions) => {
    setDraft({
      players: Object.fromEntries(Object.values(positions).map((p) => [p.pos, { ...p }])),
      throws: play.throws.map((t) => ({ ...t })),
      runner_paths: play.runner_paths.map((r) => ({ ...r })),
      explanation: play.explanation,
      coach_note: play.coach_note || "",
      staff_note: play.staff_note || "",
    });
    setSelected(null);
  }, []);

  const stop = useCallback(() => { setDraft(null); setSelected(null); }, []);

  const patchDraft = (patch) => setDraft((d) => ({ ...d, ...patch }));

  const patchPlayer = (pos, patch, ball) =>
    setDraft((d) => {
      let next = { ...d.players[pos], ...patch };
      if (patch.job) {
        next.label = JOB_LABEL[patch.job];
        const base = COVER_BASE[patch.job];
        if (base) next = { ...next, pt: cfg.bases[base], anchor: { type: "base", base } };
        if (patch.job === "fields") next = { ...next, pt: ball, anchor: { type: "ball" } };
      }
      return { ...d, players: { ...d.players, [pos]: next } };
    });

  const drag = (pos, pt) =>
    setDraft((d) => ({ ...d, players: { ...d.players, [pos]: { ...d.players[pos], pt, anchor: null } } }));

  const payload = (play, ball) => ({
    key: play.key,
    players: Object.values(draft.players).map((p) => ({
      pos: p.pos, x: round(p.pt[0]), y: round(p.pt[1]), job: p.job, label: p.label.trim() || JOB_LABEL[p.job],
      anchor: p.anchor ?? null, note: p.note?.trim() || null,
    })),
    throws: draft.throws,
    runner_paths: draft.runner_paths,
    ball: ball.map(round),
    explanation: draft.explanation,
    coach_note: draft.coach_note,
    staff_note: draft.staff_note,
  });

  return { draft, selected, setSelected, start, stop, patchDraft, patchPlayer, drag, payload };
}
